import {
  useRecordContext,
  RecordContextProvider,
  NumberField,
  useTranslate,
  DateField,
} from "react-admin";
import Box from "@mui/material/Box";

const SalesmanJournalExpandList = ({ forReport }) => {
  const record = useRecordContext();
  const t = useTranslate();
  return (
    <Box
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
        "& .RaTabbedShowLayout-content": {
          p: 0,
        },
        "& .RaLabeled-label": {
          display: "none",
        },
      }}
    >
      <Box
        component="table"
        sx={{
          width: "100%",
          // bgcolor: "rgba(0,0,0,.04)",
          // fontSize: "smaller",
          borderCollapse: "collapse",
          "& th, td": {
            padding: "2px 8px",
            border: "1px solid #dddddd",
          },
        }}
      >
        <thead>
          <tr>
            <th>{t("mine.label.code")}</th>
            <th>{t("mine.label.date")}</th>
            <th style={{ textAlign: "right" }}>Total</th>
            <th>{t("mine.label.note")}</th>
            <th>{t("mine.label.category")}</th>
          </tr>
        </thead>
        <tbody>
          {record.journals.map((item, idx) => {
            return (
              <tr key={item.id + idx}>
                <td>{item.code}</td>
                <td>
                  <RecordContextProvider value={item}>
                    <DateField
                      source="date"
                      options={{
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="total"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td>{item.note}</td>
                <td>{item.category.name}</td>
              </tr>
            );
          })}
        </tbody>
      </Box>
    </Box>
  );
};

export default SalesmanJournalExpandList;
